// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:17:45

export default {
  "id": "cube-stack-2048",
  "slug": "cube-stack-2048",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/4986d09724854afaa85f89ed717f27bc-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/4986d09724854afaa85f89ed717f27bc/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Cube Stack 2048",
      "description": "Cube Stack 2048 is a highly addictive casual game inspired by the classic puzzle game 2048, but with exciting new gameplay!\nMerge numbered cubes to double their value, reach 2048, or even higher! Try to make it to the end.\nExplore tons of amazing and challenging levels by merging cubes, avoiding obstacles, and collecting money!",
      "instructions": "Tap or mouse click to play!",
      "genres": [
        "Agility",
        "Casual"
      ],
      "tags": [
        "2048",
        "runner",
        "running",
        "stack"
      ]
    },
    "zh-CN": {
      "title": "方块堆2048",
      "description": "《立方体堆叠2048》是一款极具上瘾性的休闲游戏，灵感来源于经典益智游戏2048，但拥有令人兴奋的新玩法！\n通过合并数字立方体来翻倍它们的数值，达到2048甚至更高！努力到达游戏终点。\n通过合并立方体、避开障碍物和收集金钱，探索众多精彩且富有挑战性的关卡！",
      "instructions": "点击或鼠标点击开始游戏！",
      "genres": [
        "敏捷性",
        "休闲"
      ],
      "tags": [
        "2048",
        "跑酷",
        "奔跑",
        "叠加"
      ]
    },
    "zh-TW": {
      "title": "立方體堆疊 2048",
      "description": "Cube Stack 2048 是一款非常上癮的休闲遊戲，靈感來自經典的拼圖遊戲 2048，但具有令人興奮的新遊戲玩法！\n合併編號的立方體將其值翻倍，達到 2048，甚至更高！嘗試走到最後。\n透過合併立方體、避開障礙物和收集金錢，探索無數驚奇和挑戰性的關卡！",
      "instructions": "點擊或滑鼠點擊即可遊玩！",
      "genres": [
        "敏捷性",
        "休闲"
      ],
      "tags": [
        "2048",
        "跑酷，奔跑，疊疊高"
      ]
    },
    "zh-HK": {
      "title": "立方體堆疊 2048",
      "description": "Cube Stack 2048 是一個高度上癮的輕鬆遊戲，靈感來自經典的拼圖遊戲 2048，但加入了刺激的新遊戲體驗！\n將編號的積木合併以倍增其價值，達到 2048，甚至更高！試著達到遊戲結束。\n透過合併積木、避開障礙物和收集金錢，探索無數驚人的挑戰等級！",
      "instructions": "按鍵或滑鼠點擊開始遊戲！",
      "genres": [
        "敏捷度",
        "輕鬆遊戲"
      ],
      "tags": [
        "2048",
        "賽跑",
        "跑步",
        "疊牌"
      ]
    },
    "ja": {
      "title": "キューブスタック2048",
      "description": "キューブスタック2048は、クラスィックパズルゲーム2048にインスパイアされた非常に魅力的なカジュアルゲームで、新たな楽しいゲームプレイを提供しています！\n数字のキューブを合体させて値を2倍にし、2048に達したり、それ以上を目指して、ゲームの最後まで行きましょう。\nキューブを合体させて、障害物を避け、お金を集めながら、驚くほど魅力的で挑戦的なレベルを探求してください！",
      "instructions": "タップまたはマウスクリックで遊ぶ！",
      "genres": [
        "俊敏さ",
        "カジュアル"
      ],
      "tags": [
        "2048",
        "ランナー",
        "走行",
        "積み重ね"
      ]
    },
    "ko": {
      "title": "큐브 스택 2048",
      "description": "큐브 스택 2048은 클래식 파ズل 게임 2048을 영감으로 받은 매우 중독성이 높은 캐주얼 게임입니다! 흥미로운 새로운 게임 플레이로 즐겨보세요!\n숫자 클러스터를 합치erek 값이 두 배되도록 하고, 2048에 도달하거나 더 높은 점수를 달성해보세요! 끝까지 도달해보세요.\n큐브를 합치고 장애물을 피하고 돈을 모으며 수많은 놀라운 도전적인 레벨을 탐험해보세요!",
      "instructions": "터치나 마우스 클릭으로 게임 시작!",
      "genres": [
        "민첩성",
        "캐주얼"
      ],
      "tags": [
        "2048",
        "러너",
        "달리기",
        "쌓기"
      ]
    },
    "fr": {
      "title": "Cube Stack 2048",
      "description": "Cube Stack 2048 est un jeu casual hautement addictif inspiré du classique jeu de puzzle 2048, mais avec une jouabilité passionnante !\nFusionnez des cubes numérotés pour doubler leur valeur, atteignez 2048 ou même plus haut ! Essayez de finir le jeu.\nExplorez des niveaux incroyables et défiants en fusionnant des cubes, en évitant des obstacles et en collectant de l'argent !",
      "instructions": "Tapez ou cliquez avec la souris pour jouer !",
      "genres": [
        "Agilité",
        "Occasionnel"
      ],
      "tags": [
        "2048",
        "runner",
        "running",
        "pile"
      ]
    }
  }
};
